export default {
    '$route.name': function() {
        this.preventIncompleteUserAccess()
    }
}
